import { getParcelObservations } from '../../api/api';
import { Parcel } from '../parcels';
import { AssetObservationsState, createAssetObservationsSlice } from './abstract/asset';

const parcelObservationsSlice = createAssetObservationsSlice<Parcel>('parcels', {
  fetchObservations: getParcelObservations,
});

const { fetchAssetObservations } = parcelObservationsSlice.actions;
export { fetchAssetObservations as fetchParcelObservations };

export const { selectState: selectParcelObservationsState } = parcelObservationsSlice.getSelectors(
  (state: { observations: { parcels: AssetObservationsState<Parcel> } }) => state.observations.parcels,
);

export default parcelObservationsSlice.reducer;
